import React, { useMemo, useContext } from "react";
import StudentSchoolsList from "features/school/StudentSchoolsList";
import PersonelSchoolsList from "features/school/PersonelSchoolsList";
import { useTranslation } from "react-i18next";
import Tabs from "components/ui/tabs/Tabs";
import { AuthContext } from "shared/context/auth-context";
import { PERMISSION_TYPES } from "@routebot/constants";
import { useSearchParams } from "react-router-dom";
import { resolveTabIndexFromQuery } from "pages/shared/utility";

const SchoolsPage = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const schoolsPageTabs = useMemo(() => {
    let allTabs = [];

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_STUDENTS]) {
      allTabs.push({
        id: "schools",
        label: t("schools"),
        content: <StudentSchoolsList />,
      });
    }

    if (auth.permissions[PERMISSION_TYPES.ACCESS_TO_PERSONELS]) {
      allTabs.push({
        id: "companies",
        label: t("corporateClients"),
        content: <PersonelSchoolsList />,
      });
    }

    return allTabs;
  }, [t]);

  const tabParam = searchParams.get("tab");
  const initialTabIndex = resolveTabIndexFromQuery(tabParam, schoolsPageTabs);

  return <Tabs tabs={schoolsPageTabs} isVertical={true} id="schools-page" initialTabIndex={initialTabIndex} />;
};

export default SchoolsPage;
